import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DistributionMode } from 'api/dto/LifecycleSurveys.dto';
import { addAsyncCasesNew } from 'shared/utils/redux';

import { fetchOnboardSurveys } from './asyncActions';
import { OnboardSurveysState, STORE_NAME } from './initialState';

type SetOnboardSurveyNamePayload = {
  projectId: number;
  name: string;
};

type SetOnboardSurveyFlagsPayload = {
  projectId: number;
  sendAtWeek?: number | null;
  isActive?: boolean;
  showOnReportDashboard?: boolean;
};

export const onboardSurveysSlice = createSlice({
  name: STORE_NAME,
  initialState: OnboardSurveysState.INITIAL_DOMAIN,
  reducers: {
    setOnboardSurveyName: (state, action: PayloadAction<SetOnboardSurveyNamePayload>) => {
      const survey = state.resource.data?.onboardSurveys.find(
        ({ projectId }) => projectId === action.payload.projectId,
      );
      if (survey) {
        survey.name = action.payload.name;
      }
    },
    setOnboardSurveyFlags: (state, action: PayloadAction<SetOnboardSurveyFlagsPayload>) => {
      const survey = state.resource.data?.onboardSurveys.find(
        ({ projectId }) => projectId === action.payload.projectId,
      );
      if (!survey) {
        return;
      }
      if (action.payload.sendAtWeek !== undefined) {
        survey.sendAtWeek = action.payload.sendAtWeek;
      }
      if (action.payload.isActive !== undefined) {
        survey.isActive = action.payload.isActive;
      }
      if (action.payload.showOnReportDashboard !== undefined) {
        survey.showOnReportDashboard = action.payload.showOnReportDashboard;
      }
    },
    setDistributionMode: (state, action: PayloadAction<DistributionMode>) => {
      if (state.resource.data) {
        state.resource.data.distributionMode = action.payload;
      }
    },
  },
  extraReducers: (builder) => {
    addAsyncCasesNew(builder, fetchOnboardSurveys, (state, action) => {
      state.resource = action.payload;
    });
  },
});

export const { setOnboardSurveyName, setOnboardSurveyFlags, setDistributionMode } =
  onboardSurveysSlice.actions;
